import React, { useEffect, useRef, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import Pinned from 'Components/images/pinned.png'
import Add from 'Components/images/add.png'
import Png0 from 'Components/images/0.png'
import Png5 from 'Components/images/5.png'
import Png10 from 'Components/images/10.png'
import Png15 from 'Components/images/15.png'
import Png20 from 'Components/images/20.png'
import Png25 from 'Components/images/25.png'
import Png30 from 'Components/images/30.png'
import Png35 from 'Components/images/35.png'
import Png40 from 'Components/images/40.png'
import Png45 from 'Components/images/45.png'
import Png50 from 'Components/images/50.png'
import Png55 from 'Components/images/55.png'
import Png60 from 'Components/images/60.png'
import Png65 from 'Components/images/65.png'
import Png70 from 'Components/images/70.png'
import Png75 from 'Components/images/75.png'
import Png80 from 'Components/images/80.png'
import Png85 from 'Components/images/85.png'
import Png90 from 'Components/images/90.png'
import Png95 from 'Components/images/95.png'
import Png100 from 'Components/images/100.png'
import ListUserMenu from 'Components/images/list user menu.png'
import TaskUserMenu from 'Components/images/task user menu.png'
import NoteUserMenu from 'Components/images/note user menu.png'

import TaskPng from 'Components/images/Task Icon big.png'
import ProjectPng from 'Components/images/Project icone Big.png'
import ListIconPng from 'Components/images/List icone big.png'
import NoteIconPng from 'Components/images/Note Icone Big.png'
import Collapse from '@mui/material/Collapse'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Modal from '@mui/material/Modal'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import CreateTache from './CreateTache'
import CreateNote from './CreateNote'
import { MesTaches } from './MesTaches'
import { MNotes } from './MNotes'
import CreateProject from './CreateProject'
import { MesProjects } from './MesProjects'
import CreateListe from './CreateListe'
import { MesListe } from './MesListe'
import SyntheseTaches from './SyntheseTaches'
import CircularProgress from '@mui/material/CircularProgress'
import MenuIcon from '@mui/icons-material/Menu'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
}
const drawerWidth = 230

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  top: 'unset',
  // height: '87vh',
  background: '#4975c1',
  overflowX: 'hidden',
})

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: 'unset',
  // height: '87vh',
  background: '#4975c1',
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
})

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
)

function AddModal(props) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Modal
      open={props.modelOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ '.maintachm': { borderRadius: 2, width: isMobile ? '90%' : '500px' } }}
    >
      <Box sx={mstyle} className="maintachm">
        <Box>
          <Box
            sx={{
              textAlign: 'end',
              padding: '5px 10px',
            }}
          >
            <CloseIcon
              sx={{
                cursor: 'pointer',
              }}
              onClick={props.handleModelClose}
            />
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateTacheModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={TaskPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newTask')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newTaskHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateProjectModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                  width: '108px',
                }}
              >
                <img alt="" src={ProjectPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newProject')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newProjectHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateListeModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={ListIconPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newList')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newListHint')}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
                ':hover': {
                  background: '#f3f3f3',
                },
              }}
              onClick={() => props.CreateNoteModal()}
            >
              <Box
                sx={{
                  padding: '0 15px',
                }}
              >
                <img alt="" src={NoteIconPng} />
              </Box>
              <Box>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: 'black !important',
                    textAlign: 'left',
                  }}
                  variant="h6"
                  component="h3"
                >
                  {t('mesToDo.newNote')}
                </Typography>
                <Typography id="modal-modal-description">
                  {t('mesToDo.newNoteHint')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export const MesToDo = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [taskCat, setTaskCat] = useState('')
  const [projectTaskId, setProjectTaskId] = useState('')
  const [listeTaskId, setListeTaskId] = useState('')
  const [projectTaskName, setProjectTaskName] = useState('')
  const [listeTaskName, setListeTaskName] = useState('')
  const [priorite, setPriorite] = useState('')
  const [taskstatus, setStatus] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const handledUrlActionRef = useRef(null)
  const [project, setProject] = useState(false)
  const [noteRow, setNoteRow] = useState({})
  const [projectRow, setProjectRow] = useState({})
  const [listeRow, setListeRow] = useState({})
  const [listes, setListes] = useState(false)
  const [taches, setTaches] = useState(false)
  const [notes, setNotes] = useState(false)
  const [notesList, setNotesList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [tasksList, setTasksList] = useState([])
  const [listeList, setListeList] = useState([])
  const [createTache, setCreateTache] = useState(false)
  const [createNote, setCreateNote] = useState(false)
  const [createProject, setCreateProject] = useState(false)
  const [createListe, setCreateListe] = useState(false)
  const [modelOpen, setModelOpen] = useState(false)
  const [updateSynthese, setUpdateSynthese] = useState(false)
  const [editNote, setEdit] = useState(false)
  const [loadingDone, setLoadingDone] = useState(false)

  const [tasks1, setTasks1] = useState([])
  const [tasks2, setTasks2] = useState([])
  const [tasks3, setTasks3] = useState([])
  const [tasks4, setTasks4] = useState([])
  const [tasks5, setTasks5] = useState([])

  const IconPng = ({ row }) => {
    let total = row.tasks.length
    let done = 0
    row.tasks.map((v) => {
      if (v.Done) done++
      return ''
    })
    let num = parseFloat((done === 0 ? 0 : (done / total) * 100).toFixed(2))

    let png = Png0
    if (num > 2.5) png = Png5

    if (num > 7.5) png = Png10

    if (num > 12.5) png = Png15

    if (num > 17.5) png = Png20

    if (num > 22.5) png = Png25

    if (num > 27.5) png = Png30

    if (num > 32.5) png = Png35

    if (num > 37.5) png = Png40

    if (num > 42.5) png = Png45

    if (num > 47.5) png = Png50

    if (num > 52.5) png = Png55

    if (num > 57.5) png = Png60

    if (num > 62.5) png = Png65

    if (num > 67.5) png = Png70

    if (num > 72.5) png = Png75

    if (num > 77.5) png = Png80

    if (num > 82.5) png = Png85

    if (num > 87.5) png = Png90

    if (num > 92.5) png = Png95

    if (num > 98) png = Png100

    return <img alt="" style={{ padding: '0px', margin: '0 5px 1px 0px' }} src={png} />
  }

  const handleModelOpen = () => {
    setModelOpen(true)
    setProjectTaskId('')
  }
  const handleModelClose = () => setModelOpen(false)
  useEffect(() => {
    getData()

    // fetchTasks1()
    // fetchTasks2()
    // fetchTasks3()
    // fetchTasks4()
    // fetchTasks5()
  }, [])
  const getData = async () => {
    setLoadingDone(false)
    await fetchNotesList()
    await fetchProjectList()
    await fetchListeList()
    await fetchTasksList()
    setLoadingDone(true)
  }

  const updateTodo = async () => {
    setLoadingDone(false)
    setUpdateSynthese(!updateSynthese)
    await fetchNotesList()
    await fetchProjectList()
    await fetchListeList()
    await fetchTasksList()

    await fetchTasks1()
    await fetchTasks2()
    await fetchTasks3()
    await fetchTasks4()
    await fetchTasks5()

    setLoadingDone(true)
  }
  const fetchTasks1 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat1&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks1(data.results)
    }
  }
  const fetchTasks2 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat2&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks2(data.results)
    }
  }
  const fetchTasks3 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat3&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks3(data.results)
    }
  }
  const fetchTasks4 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat4&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks4(data.results)
    }
  }
  const fetchTasks5 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat5&limit=100',
      {},
      true,
    )
    if (status === 200) {
      setTasks5(data.results)
    }
  }
  const fetchTasksList = async (pagination = '') => {
    let url = `${urls.taskOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setTasksList(response.data.results)
    }
  }
  const fetchNotesList = async (pagination = '') => {
    let url = `${urls.noteOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setNotesList(response.data.results)
    }
  }
  const fetchProjectList = async (pagination = '') => {
    let url = `${urls.projectOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setProjectList(response.data.results)
    }
  }
  const fetchListeList = async (pagination = '') => {
    let url = `${urls.listeOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setListeList(response.data.results)
    }
  }
  const handleSynthese = () => {
    setProject(false)
    setNotes(false)
    setTaches(false)
    setListes(false)
  }
  const handleProject = () => {
    setProject(true)
    setNotes(false)
    setTaches(false)
    setListes(false)
  }
  const handleListes = () => {
    setListes(true)
    setProject(false)
    setNotes(false)
    setTaches(false)
  }
  const handleTaches = () => {
    setTaches(true)
    setProject(false)
    setNotes(false)
    setListes(false)
  }
  const handleNotes = () => {
    setNotes(true)
    setProject(false)
    setTaches(false)
    setListes(false)
  }
  const CreateTacheModal = () => {
    setCreateTache(true)
    setModelOpen(false)
  }
  const CreateNoteModal = (edit = false) => {
    // console.log(edit)
    setEdit(edit)
    setCreateNote(true)
    setModelOpen(false)
  }
  const CreateProjectModal = () => {
    setCreateProject(true)
    setModelOpen(false)
  }
  const CreateListeModal = () => {
    setCreateListe(true)
    setModelOpen(false)
  }
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }
  useEffect(() => {
    if (!loadingDone) return

    const searchParams = new URLSearchParams(location.search)
    const action = searchParams.get('action')
    const modal = searchParams.get('modal')
    const urlAction = action || modal
    const actionKey = `${location.pathname}${location.search}`

    if (handledUrlActionRef.current === actionKey) return

    if (urlAction === 'new-note') {
      handledUrlActionRef.current = actionKey
      handleNotes()
      handleDrawerOpen()
      navigate('note', { replace: true })
      CreateNoteModal()
    }
    if (urlAction === 'new-project') {
      handledUrlActionRef.current = actionKey
      handleProject()
      handleDrawerOpen()
      navigate('projects', { replace: true })
      CreateProjectModal()
    }
    if (urlAction === 'new-task') {
      handledUrlActionRef.current = actionKey
      handleTaches()
      handleDrawerOpen()
      navigate('taches', { replace: true })
      CreateTacheModal()
    }
  }, [loadingDone, location.pathname, location.search, navigate])
  const updateTodoList = (cat, data) => {
    if (cat === 'cat1') setTasks1(data)
    if (cat === 'cat2') setTasks2(data)
    if (cat === 'cat3') setTasks3(data)
    if (cat === 'cat4') setTasks4(data)
    if (cat === 'cat5') setTasks5(data)
  }
  const handleMesTaches = (priorite = '', status = '') => {
    setProjectTaskId('')
    setListeTaskId('')
    setTaskCat('')
    setPriorite(priorite)
    setStatus(status)
    handleTaches()
    navigate('taches')
  }
  function trimText(text) {
    if (text.length > 35) {
      return text.substring(0, 35) + '...' // Trim and append ellipsis
    }
    return text // Return original text if it's within the limit
  }
  const handelMobileClose = () => {
    if (isMobile) {
      setOpenDrawer(false)
    }
  }
  useEffect(() => {
    if (isMobile) {
      setOpen(true)
      setOpenDrawer(false)
    } else {
      setOpenDrawer(true)
    }
  }, [isMobile])
  return (
    <>
      <Box ml={2}>
        {isMobile && (
          <MenuIcon onClick={() => setOpenDrawer(!openDrawer)} sx={{ color: 'white' }} />
        )}
      </Box>
      <Box sx={{ display: 'flex', overflow: 'hidden', width: '100%' }}>
        {/* <CssBaseline /> */}

        <Drawer
          variant="permanent"
          open={open}
          sx={{
            display: openDrawer ? 'block' : 'none',
            height: 'auto',
            width: open ? (isMobile ? '100%' : '365px') : '60px',
            '.MuiDrawer-paper': { width: open ? (isMobile ? '100%' : '365px') : '60px' },
          }}
        >
          <DrawerHeader sx={{ justifyContent: 'flex-start' }}>
            {open ? (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '-webkit-fill-available',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        handleModelOpen()
                        handelMobileClose()
                      }}
                    >
                      <img alt="" src={Add} />
                    </IconButton>
                    {!isMobile && (
                      <IconButton onClick={handleDrawerClose}>
                        <img alt="" src={Pinned} />
                      </IconButton>
                    )}
                  </Box>
                  {/* <Box
                  sx={{
                    '& input': {
                      background: '#4975c1',
                      border: '1px solid white',
                      outline: 'unset',
                      borderRadius: '5px',
                      color: 'white',
                    },
                    '& input::placeholder': {
                      color: '#90bce3',
                      padding: '0 6px',
                    },
                  }}
                >
                  <input name="search" placeholder="Recherche" />
                </Box> */}
                </Box>
              </>
            ) : (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <IconButton onClick={handleDrawerOpen}>
                    <ChevronRightIcon sx={{ color: 'white' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      handleModelOpen()
                      handelMobileClose()
                    }}
                  >
                    <img alt="" src={Add} />
                  </IconButton>
                  {/* <IconButton onClick={handleDrawerOpen}>
                  <SearchIcon sx={{ color: 'white' }} />
                </IconButton> */}
                </Box>
              </>
            )}
          </DrawerHeader>
          <Divider />
          {open ? (
            <>
              <List
                sx={{ px: 1, color: 'white' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <ListItemButton>
                  <ListItemText
                    onClick={() => {
                      navigate('')
                      handleSynthese()
                      handelMobileClose()
                    }}
                    primary={t('mesToDo.menuSynthesisTasks')}
                  />
                </ListItemButton>
                <ListItemButton
                  sx={{ padding: '0 5px' }}
                  onClick={() => {
                    handleProject()
                    navigate('projects')
                    handelMobileClose()
                  }}
                >
                  {project ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyProjects')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={projectList.length} />
                </ListItemButton>
                <Collapse in={project} timeout="auto" unmountOnExit>
                  {projectList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setProjectTaskId(v.id)
                          setProjectTaskName(v.Name)

                          setListeTaskId('')
                          setTaskCat('')
                          setPriorite('')
                          setStatus('')
                          setProjectRow(v)
                          navigate('taches')
                          handelMobileClose()
                        }}
                      >
                        <IconPng row={v} />
                        <ListItemText primary={v.Name} />
                        <ListItemText sx={{ textAlign: 'end' }} primary={v.tasks.length} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    // setProjectTaskId('')
                    // setListeTaskId('')
                    handleListes()
                    navigate('liste')
                    handelMobileClose()
                  }}
                >
                  {listes ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyLists')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={listeList.length} />
                </ListItemButton>
                <Collapse in={listes} timeout="auto" unmountOnExit>
                  {listeList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setListeTaskId(v.id)
                          setListeTaskName(v.Name)
                          setProjectTaskId('')
                          setTaskCat('')
                          setPriorite('')
                          setStatus('')
                          setListeRow(v)
                          navigate('taches')
                          handelMobileClose()
                        }}
                      >
                        <img
                          alt=""
                          style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                          src={ListUserMenu}
                        />
                        <ListItemText primary={trimText(v.Name)} />
                        <ListItemText sx={{ textAlign: 'end' }} primary={v.tasks.length} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    handleTaches()
                    // navigate('taches')
                    handleMesTaches()
                  }}
                >
                  {taches ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyTasks')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={tasksList.length} />
                </ListItemButton>
                <Collapse in={taches} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat1')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        handelMobileClose()
                        navigate('taches')
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterToday')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks1.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat2')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterImportant')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks2.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat3')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterUpcoming')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks3.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat4')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterAnytime')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks4.length} />
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setTaskCat('cat5')
                        setProjectTaskId('')
                        setListeTaskId('')
                        setPriorite('')
                        setStatus('')
                        navigate('taches')
                        handelMobileClose()
                      }}
                      sx={{ padding: '0 8px' }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                      <ListItemText primary={t('mesToDo.filterUnclassified')} />
                      <ListItemText sx={{ textAlign: 'end' }} primary={tasks5.length} />
                    </ListItemButton>
                  </List>
                </Collapse>
                <ListItemButton
                  sx={{ padding: '0 5px', marginTop: '15px' }}
                  onClick={() => {
                    // setProjectTaskId('')
                    // setListeTaskId('')
                    handleNotes()
                    // handelMobileClose()
                  }}
                >
                  {notes ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText sx={{ marginLeft: '5px' }} primary={t('mesToDo.menuMyNotes')} />
                  <ListItemText sx={{ textAlign: 'end' }} primary={notesList.length} />
                </ListItemButton>
                <Collapse in={notes} timeout="auto" unmountOnExit>
                  {notesList.map((v) => (
                    <List key={v.id} component="div" disablePadding>
                      <ListItemButton
                        sx={{ padding: '0 8px' }}
                        onClick={() => {
                          setNoteRow(v)
                          navigate('note')
                          handelMobileClose()
                        }}
                      >
                        <img
                          alt=""
                          style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                          src={NoteUserMenu}
                        />
                        <ListItemText primary={v.Titre} />
                      </ListItemButton>
                    </List>
                  ))}
                </Collapse>
                
                {/* Shopping List Link */}
                <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
                <ListItemButton
                  sx={{ 
                    padding: '12px 15px',
                    borderRadius: '8px',
                    mx: 1,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #7e8ef5 0%, #8b5db8 100%)',
                    }
                  }}
                  onClick={() => {
                    window.location.href = '/shopping'
                  }}
                >
                  <ShoppingCartIcon sx={{ mr: 1, color: 'white' }} />
                  <ListItemText 
                    primary={t('mesToDo.menuShoppingLists')}
                    sx={{ 
                      '& .MuiListItemText-primary': { 
                        fontWeight: 600,
                        color: 'white'
                      } 
                    }} 
                  />
                </ListItemButton>
              </List>
            </>
          ) : (
            <>
              <List
                sx={{ width: '100%', maxWidth: 200, color: 'white', height: '100%' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <Box
                  sx={{
                    height: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{ marginTop: 'auto', transformOrigin: '0 0', transform: 'rotate(270deg)' }}
                  >
                    <ListItemButton sx={{ width: 'fit-content' }}>
                      <ListItemText
                        onClick={() => {
                          navigate('')
                          handelMobileClose()
                        }}
                        primary={t('mesToDo.menuSynthesisTasks')}
                      />
                    </ListItemButton>
                  </Box>
                  <Box marginTop={''}>
                    <ListItemButton
                      onClick={() => {
                        setProjectTaskId('')
                        setListeTaskId('')
                        setTaskCat('')
                        setStatus('')
                        setPriorite('')
                        handleTaches()
                        navigate('taches')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={TaskUserMenu}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleProject()
                        navigate('projects')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={Png100}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleListes()
                        navigate('liste')
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={ListUserMenu}
                      />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => {
                        // setProjectTaskId('')
                        // setListeTaskId('')
                        handleNotes()
                        handleDrawerOpen()
                        handelMobileClose()
                      }}
                    >
                      <img
                        alt=""
                        style={{ padding: '0px', margin: '0 5px 1px 0px' }}
                        src={NoteUserMenu}
                      />
                    </ListItemButton>
                    {/* Shopping List Link - Collapsed View */}
                    <ListItemButton
                      onClick={() => {
                        window.location.href = '/shopping'
                      }}
                      sx={{
                        mt: 2,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '8px',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #7e8ef5 0%, #8b5db8 100%)',
                        }
                      }}
                    >
                      <ShoppingCartIcon sx={{ color: 'white' }} />
                    </ListItemButton>
                  </Box>
                </Box>
              </List>
            </>
          )}
        </Drawer>
        <Box component="main" sx={{ flexGrow: 10, p: 0 }}>
          {/* {false ? ( */}
          {loadingDone === true ? (
            <Routes>
              <Route
                path="/"
                element={
                  <SyntheseTaches
                    open={open}
                    updateSynthese={updateSynthese}
                    handleMesTaches={handleMesTaches}
                    updateTodo={updateTodoList}
                  />
                }
              />
              <Route
                path="/taches"
                element={
                  <MesTaches
                    CreateTacheModal={CreateTacheModal}
                    updateTodo={updateTodo}
                    createTache={createTache}
                    projectTaskName={projectTaskName}
                    taskCat={taskCat}
                    projectTaskId={projectTaskId}
                    listeTaskId={listeTaskId}
                    listeTaskName={listeTaskName}
                    Priorite={priorite}
                    taskstatus={taskstatus}
                    setPriorite={setPriorite}
                    setStatus={setStatus}
                    updateTodoList={updateTodoList}
                  />
                }
              />
              <Route
                path="/note"
                element={
                  <MNotes
                    row={noteRow}
                    CreateTacheModal={CreateTacheModal}
                    updateTodo={updateTodo}
                    setNoteRow={setNoteRow}
                    CreateNoteModal={CreateNoteModal}
                    notesList={notesList}
                    setNotesList={setNotesList}
                  />
                }
              />
              <Route
                path="/projects"
                element={
                  <MesProjects
                    CreateProjectModal={CreateProjectModal}
                    updateTodo={updateTodo}
                    createProject={createProject}
                    setProjectTaskId={setProjectTaskId}
                    setProjectTaskName={setProjectTaskName}
                  />
                }
              />
              <Route
                path="/liste"
                element={
                  <MesListe
                    CreateListeModal={CreateListeModal}
                    updateTodo={updateTodo}
                    createListe={createListe}
                    setListeTaskId={setListeTaskId}
                    setListeTaskName={setListeTaskName}
                  />
                }
              />
            </Routes>
          ) : (
            <Box
              sx={{
                display: 'flex',
                height: '90vh',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
        <AddModal
          modelOpen={modelOpen}
          CreateProjectModal={CreateProjectModal}
          CreateListeModal={CreateListeModal}
          updateTodo={updateTodo}
          handleModelClose={handleModelClose}
          CreateTacheModal={CreateTacheModal}
          CreateNoteModal={CreateNoteModal}
        />
        {createTache && (
          <CreateTache
            setCreateTache={setCreateTache}
            projectTaskId={projectTaskId}
            updateTodo={updateTodo}
            listeTaskId={listeTaskId}
          />
        )}
        {createNote && (
          <CreateNote
            setCreateNote={setCreateNote}
            setNoteRow={setNoteRow}
            updateTodo={updateTodo}
            setNotesList={setNotesList}
            setEdit={setEdit}
            editNote={editNote}
          />
        )}
        {createProject && (
          <CreateProject
            setCreateProject={setCreateProject}
            setProjectRow={setProjectRow}
            updateTodo={updateTodo}
            setProjectList={setProjectList}
            /* LAP-fix-projet-vs-objectif — Quand on ouvre CreateProject depuis
               le Conseiller Patrimonial via /todos?action=new-project, on lit
               le prefill dans location.state pour pré-remplir Name / Objectifs.
               Tant que CreateProject ne lit pas explicitement la prop, c'est
               sans effet (no-op), donc rétrocompatible. */
            prefill={location.state?.prefill}
          />
        )}
        {createListe && (
          <CreateListe
            setCreateListe={setCreateListe}
            setListeList={setListeList}
            updateTodo={updateTodo}
          />
        )}
      </Box>
    </>
  )
}
